// Legacy image-label questions were imported as empty choice lists even though
// their answer keys contain words. Keep their saved IDs and answer keys intact.
export const normalizeLegacyTextChoice = (question = {}, parentType = '') => {
  const type = question.responseType || question.type;
  const answer = question.acceptedAnswer || question.correctAnswer || question.answerGuide;
  const writtenParent = ['describe-image', 'name-following', 'short-answer', 'long-answer', 'diagram-questions'].includes(parentType);
  if (writtenParent && ['multiple-choice', 'image-multiple-choice'].includes(type)
    && !(question.options || []).some(option => String(option || '').trim())
    && typeof answer === 'string' && answer.trim() && !/^\d+$/.test(answer.trim())) {
    return { ...question, responseType: 'short-answer', options: [], acceptedAnswer: answer };
  }
  return question;
};

const trimTrailingEmptyEntries = (items = []) => {
  const trimmed = [...items];
  while (trimmed.length && !String(trimmed[trimmed.length - 1] || '').trim()) trimmed.pop();
  return trimmed;
};

export const sanitizeTrafficCourseTasks = (tasks = []) => tasks.map(task => ({
  ...task,
  questions: (task.questions || []).map(question => ({
    ...question,
    options: trimTrailingEmptyEntries(question.options || []),
    matchingPairs: (question.matchingPairs || []).filter(pair => String(pair.left || '').trim() || String(pair.right || '').trim()),
    orderingItems: (question.orderingItems || []).filter(item => String(item.text || '').trim()),
    subQuestions: (question.subQuestions || []).map(part => ({
      ...normalizeLegacyTextChoice(part, question.type),
      options: trimTrailingEmptyEntries(normalizeLegacyTextChoice(part, question.type).options || []),
    })),
  })),
}));
